import { initializeLogger } from '@seamless/logger';
import { type Logger } from './types';

export function createLogger(): Logger {
  const aemNamespace = (window as any).aemNamespace;
  return initializeLogger(import.meta.env.APP_NAME, {
    tenant: 'owpi',
    configs: {
      env: aemNamespace?.pageEnvironmentVariables?.stageVariant,
      component: import.meta.env.APP_NAME,
      componentVersion: import.meta.env.APP_VERSION,
      market: aemNamespace?.pageEnvironmentVariables?.country,
      language: aemNamespace?.pageEnvironmentVariables?.language,
      modelSeries: aemNamespace?.vehicleContext?.modelSeries,
      subBrand: aemNamespace?.vehicleData?.subBrands?.[0], // This should be overridden in SPA when switching style
    },
  });
}
